import { render, staticRenderFns } from "./MpsDataTable.vue?vue&type=template&id=4320ced3&scoped=true"
import script from "./MpsDataTable.vue?vue&type=script&lang=js"
export * from "./MpsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4320ced3",
  null
  
)

export default component.exports